<template>
  <div class="wrapper">
    <div class="stepInput">
      <el-row>
        <el-col :span="4">
          <el-menu
            :default-active="settingActive"
            @select="menuSelect"
            unique-opened
            @open="(idx) => (settingActive = idx + '-0')"
            class="el-menu-vertical-demo"
          >
            <el-submenu
              :index="frtIdx + ''"
              v-for="(frtNav, frtIdx) in settingNav"
              :key="'firstNav' + frtIdx"
            >
              <template slot="title">
                <el-image
                  fit="contain"
                  style="width: 20px; height: 20px"
                  :src="frtNav.icon"
                  alt=""
                />
                {{ frtNav.title }}</template
              >
              <div v-if="frtNav.children && frtNav.children.length">
                <el-menu-item
                  :index="frtIdx + '-' + secIdx"
                  v-for="(secNav, secIdx) in frtNav.children"
                  @click="navClick([frtIdx, secIdx])"
                  :key="'secNav' + secIdx"
                  >{{ secNav.title }}</el-menu-item
                >
              </div>
            </el-submenu>
          </el-menu>
        </el-col>
        <el-col
          :span="20"
          :class="[
            'contentSide',
            $route.query.id ? 'contentSideEdit' : 'contentSideCreate',
          ]"
        >
          <div class="settingContent" v-show="settingActive.indexOf('0-') > -1">
            <div class="inputBar">
              <div class="title">有效限期</div>
              <el-radio-group v-model="settingData.validDateSet">
                <el-radio :label="2">永久有效</el-radio>
                <br /><el-radio :label="1"
                  >试卷开放时间
                  <el-date-picker
                    @change="upToDatePicker"
                    :time-arrow-control="true"
                    v-model="settingData.upToDate"
                    v-show="settingData.validDateSet == 1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    size="small"
                  >
                  </el-date-picker
                ></el-radio>
                <br />
                <el-radio :label="3">不可用</el-radio>
              </el-radio-group>
            </div>
            <div class="inputBar">
              <div class="title">答卷次数</div>
              <el-radio-group v-model="settingData.answerNumberSet">
                <el-radio :label="1">无数次</el-radio>
                <br />
                <el-radio :label="2">一次</el-radio> <br />
                <el-radio :label="3"
                  >多次<el-input
                    placeholder="请输入内容"
                    v-model="settingData.answerNumber"
                  ></el-input
                ></el-radio>
                <br />
                <el-radio :label="4"
                  >每人每天<el-input
                    placeholder="请输入内容"
                    v-model="settingData.answerNumber"
                  ></el-input
                ></el-radio>
              </el-radio-group>
            </div>
            <div class="inputBar">
              <div class="title">答卷时间控制</div>
              <span
                :class="{
                  'el-radio__input': true,
                  'is-checked':
                    settingData.timeControl == 1 ||
                    settingData.timeControl == 2,
                }"
                style="display: flex; margin-top: 20px"
                @click="settingData.timeControl = 1"
              >
                <span class="el-radio__inner"> </span>
                <input
                  class="el-radio__original"
                  type="radio"
                  :checked="
                    settingData.timeControl == 1 || settingData.timeControl == 2
                  "
                />
                <span style="margin-left: 10px">答卷时间</span>
              </span>

              <div style="padding: 0 20px; width: 100%">
                <el-radio :label="1" v-model="settingData.timeControl"
                  >独立时间 &nbsp;&nbsp;答题时长:
                  <el-input v-model="settingData.answerExamDuration">
                  </el-input>
                  分钟
                </el-radio>
                (在规定的开放/时间内，考生无论何时进入答题，
                都不影响答卷时长，且设置为0表示不限时长。)
                <br />
                <el-radio :label="2" v-model="settingData.timeControl"
                  >动态时间
                </el-radio>
                （动态时间对答题时长有影响，考生越晚进入答题，
                剩余的时长越短；如设置为下午1点到3点，当考生2点进入考试，
                则只剩下1个小时答题时长）
              </div>

              <!-- <br />
              <el-radio :label="3" v-model="settingData.timeControl"
                >单题作答时间:<el-input
                  v-model="settingData.singleQuestionDuration"
                ></el-input
              ></el-radio> -->
              <br />
              中断保存时间:<el-select
                v-model="settingData.interruptSaveDuration"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [1, 5, 10, 15, 20, 30, 40, 60, 90, 120, 0]"
                  :key="item"
                  :label="item || '不限时间'"
                  :value="item"
                >
                </el-option> </el-select
              >分钟<span class="greyFont"
                >（考试中断后，在设置的时间内可返回继续作答。）</span
              >
            </div>
          </div>
          <div class="settingContent" v-show="settingActive.indexOf('1-') > -1">
            <div class="inputBar">
              <div class="title">登陆考试方式</div>
              <el-radio v-model="settingData.loginMethod" :label="1"
                >所有人可考</el-radio
              ><br />
              <el-radio v-model="settingData.loginMethod" :label="2"
                >账号登陆考试</el-radio
              >
              <div class="inputBar" v-show="settingData.loginMethod == 2">
                <el-checkbox
                  v-model="settingData.ifParticularGroup"
                  :true-label="1"
                  :false-label="0"
                  >指定组考试</el-checkbox
                ><br />
                <div
                  class="chooseContainer"
                  v-show="settingData.ifParticularGroup"
                >
                  <tree-select
                    :groupTree="studentGroupList"
                    :groupChosenIds="settingData.studentGroupIds"
                    :showCheckbox="true"
                    :checkStrictly="true"
                    @eventUp="studentGroupEvent"
                    :check-on-click-node="true"
                    ref="studentGroupSelectTree"
                  ></tree-select>
                </div>
                <el-checkbox
                  v-model="settingData.ifParticularStudent"
                  :true-label="1"
                  :false-label="0"
                  >指定考生考试</el-checkbox
                >
                <br />
                <div
                  class="chooseContainer"
                  v-if="settingData.ifParticularStudent"
                >
                  <student-choose
                    :studentList="[...settingData.studentList]"
                    @eventUp="studentChooseUp"
                  ></student-choose>
                </div>
              </div>
              <div>
                <el-radio v-model="settingData.loginMethod" :label="3"
                  >通过访问码考试</el-radio
                >
                <div class="visitCodeBox" v-show="settingData.loginMethod == 3">
                  <h2>访问码：{{ settingData.accessCode }}</h2>
                  <el-button
                    type="primary"
                    size="large"
                    @click="copy(settingData.accessCode)"
                    >复制</el-button
                  >
                  <el-button
                    plain
                    type="primary"
                    size="large"
                    @click="
                      settingData.accessCode =
                        parseInt((Math.random() * 9000) / 1) + 1000
                    "
                    >{{
                      settingData.accessCode ? "重新" : ""
                    }}生成访问码</el-button
                  >
                </div>
              </div>
            </div>
            <div class="inputBar">
              <div class="title">收集考生信息</div>
              <el-checkbox-group v-model="collectionChosen">
                <el-checkbox
                  v-for="collect in collectionList"
                  :label="collect.label"
                  :key="collect.label"
                  >{{ collect.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div class="inputBar">
              <div class="title">
                <el-checkbox
                  v-model="settingData.loginBeforeExam"
                  :true-label="1"
                  :false-label="0"
                  >开启考前登录</el-checkbox
                >
              </div>
            </div>

            <div class="inputBar">
              <div class="title">考试说明</div>
              <el-radio-group v-model="settingData.examDescription">
                <el-radio :label="1">不显示</el-radio><br />
                <el-radio :label="2">只显示默认说明</el-radio><br />
                <el-radio :label="3">只显示自定义说明</el-radio><br />
                <el-radio :label="4">显示默认说明+自定义说明</el-radio>
              </el-radio-group>
              <div
                class="defaultDescriptBox"
                v-show="
                  settingData.examDescription == 2 ||
                  settingData.examDescription == 4
                "
              >
                <div class="spaceBwteen">
                  <span>考试次数</span><span>不限</span>
                </div>
                <div class="spaceBwteen">
                  <span>考试限时</span><span>30分钟</span>
                </div>
                <div class="spaceBwteen">
                  <span>及格分数</span><span>60%</span>
                </div>
                <div class="spaceBwteen">
                  <span>考试规则</span><span>允许考生返回修改答案</span>
                </div>
              </div>
              <div
                class="editorContainer"
                v-show="
                  settingData.examDescription == 3 ||
                  settingData.examDescription == 4
                "
              >
                自定义说明
                <div ref="customDescription"></div>
              </div>
            </div>
          </div>
          <!-- 
        
        missedScoreIndefinite: 1, -->
          <div class="settingContent" v-show="settingActive.indexOf('2-') > -1">
            <div class="inputBar">
              <div class="title">显示设置</div>
              <el-input
                style="width: 80px"
                size="mini"
                v-model="settingData.questionNum"
              ></el-input
              >题/页 <br />
              试题排序
              <el-radio-group v-model="settingData.outOfOrder">
                <el-radio :label="0">默认</el-radio>
                <el-radio :label="1">乱序</el-radio>
              </el-radio-group>
              <br />
              <el-checkbox
                v-model="settingData.skipPage"
                :true-label="1"
                :false-label="0"
                >自动跳页
                <span class="greyFont">(仅支持单选题)</span></el-checkbox
              ><br />
              <el-checkbox
                v-model="settingData.compressPicture"
                :true-label="1"
                :false-label="0"
                >将试题的大图(大于150px)自动以缩略图有序排列
                <span class="greyFont"
                  >(使试题更美观，支持点击缩略图放大)</span
                ></el-checkbox
              >
            </div>
            <div class="inputBar">
              <div class="title">问答题答案设置</div>
              <el-checkbox
                v-model="settingData.voicePhotoAnswer"
                :true-label="1"
                :false-label="0"
                >问答题开启语音、拍照回答</el-checkbox
              ><br /><el-checkbox
                v-model="settingData.uploadAnnexAnswer"
                :true-label="1"
                :false-label="0"
                >问答题开启上传附件回答<br />
              </el-checkbox>
            </div>
            <div class="inputBar">
              <div class="title">音频播放次数设置</div>
              <el-select
                v-model="settingData.audioPlayNum"
                style="width: 80px"
                size="mini"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in [0, 1, 2, 3, 4, 5]"
                  :key="'audioPlayNum' + item"
                  :label="item ? item : '不限'"
                  :value="item"
                >
                </el-option> </el-select
              >次 <span class="greyFont">(限制音频题中的音频可播放次数)</span>
            </div>
            <div class="inputBar">
              <div class="title">答题规则</div>
              <el-row>
                <el-col :span="4">强制性</el-col>
                <el-col :span="20">
                  <el-checkbox
                    v-model="settingData.submitExamRule"
                    :true-label="1"
                    :false-label="0"
                    >必须回答完所有试题才能交卷 </el-checkbox
                  ><span class="greyFont"
                    >(答卷者必须回答完所有题目，才可以交卷，除非已到考试时间)</span
                  >
                  <br />
                  <el-checkbox
                    v-model="settingData.nextQuestion"
                    :true-label="1"
                    :false-label="0"
                    >答对后才能继续回答下一题
                  </el-checkbox>
                  <span class="greyFont"
                    >(答卷者要求回答正确每一题才能进行下一题，否则答卷将结束)</span
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">练习模式</el-col>
                <el-col :span="20">
                  <el-radio v-model="settingData.practiceMode" :label="1"
                    >不开启</el-radio
                  >
                  <br />
                  <el-radio v-model="settingData.practiceMode" :label="2"
                    >每答完一题立即查看答案和解析</el-radio
                  ><br /><el-radio v-model="settingData.practiceMode" :label="3"
                    >只在答错时显示答案和解析</el-radio
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">改变答案</el-col>
                <el-col :span="20">
                  <el-checkbox
                    v-model="settingData.changeAnswer"
                    :true-label="1"
                    :false-label="0"
                    >允许考生返回修改答案 </el-checkbox
                  ><span class="greyFont"
                    >(答卷者必须回答完所有题目，才可以交卷，除非已到考试时间)</span
                  >
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4">漏选得分</el-col>
                <el-col :span="20">
                  <el-checkbox
                    v-model="settingData.missedScoreMultiple"
                    :true-label="1"
                    :false-label="0"
                    >允许多选题漏选按比例得分
                  </el-checkbox>
                  <span class="greyFont"
                    >(例正确答案为ABC，满分为3分，考生只选了AB，按比例可得2分)</span
                  ><br />
                  <el-checkbox
                    v-model="settingData.missedScoreIndefinite"
                    :true-label="1"
                    :false-label="0"
                    >允许不定项选择题漏选按比例得分 </el-checkbox
                  ><span class="greyFont"
                    >(例正确答案为ABCD，满分为3分，考生只选了AB，按比例可得1.5分)</span
                  >
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="settingContent" v-show="settingActive.indexOf('3-') > -1">
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.pageSwitch"
                :true-label="1"
                :false-label="0"
                >页面切换次数超
                <el-input
                  style="width: 60px"
                  size="mini"
                  v-model="settingData.pageSwitchNum"
                ></el-input>
                次后，系统强制交卷</el-checkbox
              >
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.examInterruption"
                :true-label="1"
                :false-label="0"
                >考试中断次数超过
                <el-input
                  style="width: 60px"
                  size="mini"
                  v-model="settingData.examInterruptionNum"
                ></el-input>
                次后，系统自动交卷</el-checkbox
              ><span class="greyFont">(中断时间超过10s即为一次)</span>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.occupyScreen"
                :true-label="1"
                :false-label="0"
                >开启霸屏功能
              </el-checkbox>
              <span class="greyFont"
                >（仅支持在Windows电脑上运行，支持播放音视频）
              </span>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.prohibitCopy"
                :true-label="1"
                :false-label="0"
                >答题过程禁止复制试题
              </el-checkbox>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.prohibitPaste"
                :true-label="1"
                :false-label="0"
                >答题过程禁止粘贴内容
              </el-checkbox>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.dualCameras"
                :true-label="1"
                :false-label="0"
                >是否开启小程序摄像头监考
              </el-checkbox>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.cameraInvigilation"
                :true-label="1"
                :false-label="0"
                >启用摄像头监考
              </el-checkbox>
              <span class="greyFont"
                >(需要有摄像头，无摄像头将无法考试，当前仅支持电脑。)</span
              >
              <div
                class="inputSecBar"
                v-show="settingData.cameraInvigilation == 1"
              >
                需要拍摄<el-input
                  placeholder="请输入内容"
                  size="mini"
                  v-model="settingData.pictureNum"
                ></el-input
                >张照片(最多5张)
              </div>
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.faceRecognition"
                :true-label="1"
                :false-label="0"
                :disabled="settingData.loginMethod != 2"
                >开启人脸识别
              </el-checkbox>
              <span
                :class="settingData.loginMethod == 2 ? 'greyFont' : 'redFont'"
                >(只有通过账号登陆考试可使用)</span
              >
            </div>
            <div class="inputBar">
              <el-checkbox
                v-model="settingData.antiCheatMonitoring"
                :true-label="1"
                :false-label="0"
                >开启智能防作弊检监测
              </el-checkbox>
              <span class="greyFont">(需要开启摄像头头监考)</span>
              <div
                class="inputSecBar"
                v-show="settingData.antiCheatMonitoring == 1"
              >
                检测到多个人脸存在超过<el-input
                  placeholder="请输入内容"
                  size="mini"
                  type="number"
                  v-model="settingData.multipleFacesNum"
                ></el-input
                >次，系统强制交卷 <br />
                检测到人脸不是本人超过<el-input
                  placeholder="请输入内容"
                  type="number"
                  size="mini"
                  v-model="settingData.faceNoOwnNum"
                ></el-input
                >次，系统强制交卷 <br />
                检测考生有低头、扭头等小动作超过<el-input
                  placeholder="请输入内容"
                  type="number"
                  size="mini"
                  v-model="settingData.littleActionNum"
                ></el-input
                >次，系统强制交卷 <br />
                声音灵敏度：<el-select
                  v-model="settingData.soundSensitivity"
                  type="number"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in ['低', '中', '高']"
                    :key="'soundSensitivity' + item"
                    :label="item"
                    :value="item"
                  >
                  </el-option> </el-select
                ><br />
                检测到考试时有大于设置的灵敏度的声音存在超过<el-input
                  placeholder="请输入内容"
                  type="number"
                  size="mini"
                  v-model="settingData.exceedSensitivityNum"
                ></el-input
                >次，系统强制交卷
              </div>
            </div>
          </div>
          <div class="settingContent" v-show="settingActive.indexOf('4-') > -1">
            <div class="inputBar">
              <div class="title">提交答卷：</div>
              <el-radio v-model="settingData.showGrades" :label="1"
                >显示成绩</el-radio
              >&ensp;
              <el-radio v-model="settingData.showGrades" :label="0"
                >不显示成绩</el-radio
              >
            </div>
            <el-divider></el-divider>
            <div class="inputBar" v-show="settingData.showGrades == 1">
              <el-radio-group v-model="settingData.scoresReviews">
                <el-radio :label="1">仅得分和评语</el-radio><br />
                <el-radio :label="2"
                  >得分、评语、解析
                  <span class="greyFont">(隐藏正确答案)</span></el-radio
                ><br />
                <el-radio :label="3"
                  >得分、评语、解析<span class="greyFont"
                    >(含正确答案)</span
                  ></el-radio
                >
              </el-radio-group>
              <br />
              <input
                type="checkbox"
                :checked="settingData.showRank != 0"
                @click="settingData.showRank = settingData.showRank ? 0 : 1"
              />
              <span style="margin-left: 10px"
                >显示当前排名和排行榜
                <span class="greyFont"
                  >(排名显示上限
                  <el-select
                    v-model="settingData.rankUpperLimit"
                    placeholder="请选择"
                    style="width: 80px"
                    size="mini"
                  >
                    <el-option
                      v-for="item in [10, 20, 50]"
                      :key="'rankUpperLimit' + item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  )</span
                ></span
              >
              <div class="inputSecBar" v-show="settingData.showRank">
                <el-radio v-model="settingData.showRank" :label="1"
                  >按成绩进行排行
                  <span class="greyFont"
                    >(排行榜以每次的成绩进行排行)</span
                  ></el-radio
                >
                <br /><el-radio v-model="settingData.showRank" :label="2"
                  >按人进行排行
                  <span class="greyFont"
                    >(排行榜以考生最好的成绩进行排行)</span
                  ></el-radio
                >
              </div>
              <br />
              <el-checkbox
                v-model="settingData.gradeQueryCode"
                :true-label="1"
                :false-label="0"
                >显示成绩查询码</el-checkbox
              ><br /><el-checkbox
                v-model="settingData.shareButton"
                :true-label="1"
                :false-label="0"
                >显示分享按钮</el-checkbox
              ><br /><el-checkbox
                v-model="settingData.queryMoreExam"
                :true-label="1"
                :false-label="0"
                >允许查看更多试卷</el-checkbox
              ><br /><el-checkbox
                v-model="settingData.scoreReportLink"
                :true-label="1"
                :false-label="0"
                >显示考生成绩报告链接</el-checkbox
              ><br /><el-checkbox
                v-model="settingData.noWrongQuestionSet"
                :true-label="1"
                :false-label="0"
                >考生后台不显示改试卷的错题集</el-checkbox
              ><br />
              自动跳转：<br />
              在结果页面显示
              <el-input
                size="small"
                style="width: 60px"
                v-model="settingData.automaticJumpTime"
              ></el-input>
              秒后跳转到<el-input
                size="small"
                style="width: 200px"
                v-model="settingData.jumpLink"
              ></el-input
              ><span class="greyFont">(0秒 表示不跳转)</span>
              <br />分享语：<el-input
                size="small"
                style="width: 400px"
                v-model="settingData.sharingLanguage"
              ></el-input>
              <div class="inputSecBar">
                <el-radio v-model="settingData.showRank" :label="1"
                  >按成绩进行排行
                  <span class="greyFont"
                    >(排行榜以每次的成绩进行排行)</span
                  ></el-radio
                >
                <br /><el-radio v-model="settingData.showRank" :label="2"
                  >按人进行排行
                  <span class="greyFont"
                    >(排行榜以考生最好的成绩进行排行)</span
                  ></el-radio
                >
              </div>
            </div>
            <div class="inputBar" v-show="settingData.showGrades == 0">
              <el-radio v-model="settingData.prompt" label="0"
                >显示默认提示
                <span class="greyFont"
                  >(你的考试已提交，感谢参与作答)</span
                ></el-radio
              ><br />
              <el-radio
                v-model="settingData.prompt"
                :label="settingData.prompt == '0' ? '' : settingData.prompt"
                >自定义文字
              </el-radio>
              <br />
              <el-input
                size="small"
                v-model="settingData.prompt"
                v-show="settingData.prompt != '0'"
              ></el-input>
              <br />
              <el-checkbox
                v-model="settingData.queryMoreExam"
                :true-label="1"
                :false-label="0"
                >允许查看更多试卷</el-checkbox
              ><br />
              自动跳转：<br />
              在结果页面显示
              <el-input
                size="small"
                style="width: 60px"
                v-model="settingData.automaticJumpTime"
              ></el-input>
              秒后跳转到<el-input
                size="small"
                style="width: 200px"
                v-model="settingData.jumpLink"
              ></el-input
              ><span class="greyFont">(0秒 表示不跳转)</span>
              <br />分享语：<el-input
                size="small"
                style="width: 400px"
                v-model="settingData.sharingLanguage"
              ></el-input>
            </div>
            <div class="inputBar">
              <div class="title">评语设置</div>
              及格分数：<el-input
                size="small"
                style="width: 60px"
                max="100"
                v-model="settingData.passScore"
              ></el-input
              >%
              <div class="editorContainer">
                及格评语：
                <div :ref="'passComment'"></div>
              </div>
              <div class="editorContainer">
                不及格评语：
                <div :ref="'noPassComment'"></div>
              </div>
            </div>
            <!-- <div class="inputBar">
              <div class="title">自动交卷</div>
              <el-radio-group v-model="settingData.automaticSubmit">
                <el-radio :label="1">不使用自动系统交卷</el-radio> <br />
                <el-radio :label="2">超过“考试开放时间”后自动交卷</el-radio>
                <br />
                <el-radio :label="3">离开考试超过一个小时后自动交卷</el-radio>
              </el-radio-group>
            </div> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="dialogData.title"
      :visible.sync="dialogData.ifShow"
      :width="dialogData.width || 60 + '%'"
      :before-close="closeDialog"
      :modal-append-to-body="false"
    >
      <!-- @node-click="nodeClick" -->

      <el-tree
        :data="studentGroupList"
        show-checkbox
        :check-on-click-node="true"
        default-expand-all
        node-key="id"
        ref="studentGroupTree"
        fullscreen
        highlight-current
        :props="{ label: 'title' }"
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="groupConfirm">选 择</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "wangeditor";
import { getSetting } from "@/api/examination/examination.js";
import {
  getStudentGroup,
  deleteStudentGroup,
  editStudentGroup,
  createStudentGroup,
} from "@/api/examination/student.js";
import treeSelect from "@/component/tree/treeSelect.vue";
import studentChoose from "@/component/tree/studentChoose.vue";
export default {
  data() {
    return {
      settingData: {
        // 试卷权限
        validDateSet: 2,
        startTime: "",
        endTime: "",
        upToDate: [],
        answerNumberSet: 1,
        answerNumber: 1,
        timeControl: 1,
        dualCameras: 0,
        outOfOrder: 0,
        answerExamDuration: 120,
        shortestExamDuration: 30,
        singleQuestionDuration: 1,
        interruptSaveDuration: 10,
        // 进入考试设置
        loginMethod: 1,
        studentGroupIds: [],
        ifParticularGroup: 0,
        ifParticularStudent: 0,
        studentIds: [],
        tudentChosen: [],
        confirmIdentity: 0,
        bindWechat: 0,
        accessCode: "1234",
        collectStudentInfo: {},
        // 手机验证缺失,
        loginBeforeExam: 0,
        examDescription: 1,
        customDescription: "",
        questionNum: 1,
        skipPage: 0,
        compressPicture: 0,
        voicePhotoAnswer: 0,
        uploadAnnexAnswer: 0,
        audioPlayNum: 0,
        submitExamRule: "",
        nextQuestion: 0,
        practiceMode: 1,
        changeAnswer: 0,
        missedScoreMultiple: 0,
        missedScoreIndefinite: 0,

        pageSwitch: 0,
        pageSwitchNum: 10,
        examInterruption: 0,
        examInterruptionNum: 10,
        occupyScreen: 0,
        prohibitCopy: 0,
        prohibitPaste: 0,
        cameraInvigilation: 0,
        pictureNum: 5,
        faceRecognition: 0,
        antiCheatMonitoring: 0,
        multipleFacesNum: 3,
        faceNoOwnNum: 3,
        littleActionNum: 3,
        soundSensitivity: "低",
        exceedSensitivityNum: 3,
        //  只能防作弊缺失
        // 结果页面
        showGrades: 1,
        scoresReviews: 1,
        showRank: 0,
        rankUpperLimit: 10,
        gradeQueryCode: 0,
        shareButton: 0,
        queryMoreExam: 0,
        scoreReportLink: 0,
        noWrongQuestionSet: 0,
        automaticJumpTime: 20,
        jumpLink: "",
        prompt: "0",
        sharingLanguage: "",
        comment: "",
        passScore: 60,
        passComment: "",
        noPassComment: "",
        automaticSubmit: 1,
        afterExamReward: 1,
        redEnvelopeBalance: 0, //红包余额
        randomDrawRedEnvelope: 0,
        randomDrawPrize: 0,
        winNum: {},

        // 考生报告设置
        content: "",
        passRate: "",
        passSuggest: "",
        noPassSuggest: "",
        prompt: "",
        status: 0,
      },
      settingActive: "0-0",

      settingNav: [
        {
          title: "试卷权限",
          href: "power",
          icon: require("@/assets/img/pen.png"),
          children: [
            { title: "有效限期", href: "" },
            { title: "答卷次数", href: "" },
            { title: "答题时间控制", href: "" },
          ],
        },
        {
          title: "进入考试设置",
          href: "enterSetting",
          icon: require("@/assets/img/enter.png"),
          children: [
            { title: "登录考试方式", href: "" },
            { title: "收集考生信息", href: "" },
            { title: "考试说明", href: "" },
          ],
        },
        {
          title: "试卷设置",
          href: "examinationSetting",
          icon: require("@/assets/img/set.png"),
          children: [
            { title: "显示设置", href: "" },
            { title: "问答题答案设置", href: "" },
            { title: "音视频播放次数设置", href: "" },
            { title: "答题规则", href: "" },
          ],
        },
        {
          title: "防作弊设置",
          href: "cheatingSetting",
          icon: require("@/assets/img/defent.png"),
        },
        {
          title: "结果界面",
          href: "resultSetting",
          icon: require("@/assets/img/book.png"),
          children: [
            { title: "提交答卷", href: "" },
            { title: "评语设置", href: "" },
            { title: "自动交卷", href: "" },
          ],
        },
      ],
      collectionList: [
        { label: "姓名", value: "", valueList: [] },
        { label: "手机", value: "", valueList: [] },
        { label: "身份证", value: "", valueList: [] },
        { label: "邮箱", value: "", valueList: [] },
        { label: "QQ", value: "", valueList: [] },
        { label: "微信号", value: "", valueList: [] },
      ],
      editorList: {
        customDescription: "",
        passComment: "",
        noPassComment: "",
      },
      collectionChosen: [],
      studentGroupChosen: [],
      dialogData: { title: "标题", ifShow: false },
      studentGroupList: [],
    };
  },
  props: {
    examId: [String, Number],
  },
  watch: {
    "settingData.studentList"() {
      this.settingData.studentIds = this.settingData.studentList.map(
        (item) => item.id
      );
      console.log(this.settingData.studentIds);
    },
  },
  components: { treeSelect, studentChoose },
  created() {},
  mounted() {
    getSetting({ examId: this.examId || this.$route.query.id }).then((data) => {
      if (data.collectStudentInfo) {
        this.collectionChosen = Object.keys(
          JSON.parse(data.collectStudentInfo)
        ); //收集考生信息转化
      }
      data.upToDate = data.startTime ? [data.startTime, data.endTime] : "";
      data.studentList = data.studentList || [];
      // data.studentChosenList = [...data.studentList];
      this.settingData = data;
      this.editorInit();
      console.log(data);
    });
    this.studentGroupInit();

    this.scrollInit();
  },
  methods: {
    showData() {
      let postData = {};
      Object.assign(postData, this.settingData);
      postData.collectStudentInfo = JSON.stringify(
        this.collectionChosen.reduce((total, item) => {
          total[item] = "";
          return total;
        }, {})
      );
      for (let key in this.editorList) {
        postData[key] = this.editorList[key].txt.html();
      }

      this.$emit("postSetting", postData);
    },
    studentGroupEvent(eventDetail, treeData) {
      // console.log(type, option.chosenKeys);
      switch (eventDetail.type) {
        case "chosenKeysConfirm":
          this.settingData.studentGroupIds = eventDetail.chosenKeys;
          break;
        case "rename":
          editStudentGroup({
            id: eventDetail.contextData.id,
            // parentId: eventDetail.contextData.parentId,
            groupName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteStudentGroup({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          createStudentGroup({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          editStudentGroup({
            id: eventDetail.id,
            parentId: eventDetail.parentId,
            // groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        case "chosen":
          console.log(eventDetail);
          this.settingData.studentGroupChosen = eventDetail.value;
          break;
        case "select":
          this.temporaryTree = eventDetail.value;
          break;
        case "confirm":
          // this.examinationType = this.temporaryTree;
          this.applyData.groupId = this.temporaryTree.id;
          break;
        default:
          break;
      }
    },
    studentChooseUp(option) {
      switch (option.type) {
        case "confirm":
          this.settingData.studentList = [...option.value];

          break;
        case "delete":
          this.settingData.studentList.splice(option.value, 1);
        default:
          break;
      }
    },
    studentGroupInit() {
      getStudentGroup().then((data) => {
        // data.groupNodeList.forEach(item=>{item.choose=false})
        console.log(data);
        this.studentGroupList = data;
      });
    },
    menuSelect(activeNav) {
      this.settingActive = activeNav;
    },
    showStudentGroupDialog() {
      this.dialogData.ifShow = true;
      this.$nextTick(() => {
        this.$refs.studentGroupTree.setCheckedNodes(this.studentGroupChosen);
      });
    },
    editorInit() {
      let editorList = ["customDescription", "passComment", "noPassComment"];
      editorList.forEach((item) => {
        let contentEditor = new Editor(this.$refs[item]);
        contentEditor.config.menus = editorMenus;
        contentEditor.config.showFullScreen = false;
        contentEditor.create();
        contentEditor.$textContainerElem.elems[0].style.height = "133px";
        if (this.settingData[item]) {
          contentEditor.txt.html(this.settingData[item]);
        }

        this.editorList[item] = contentEditor;
      });
    },
    closeDialog() {
      this.dialogData.ifShow = false;
    },

    groupConfirm() {
      this.studentGroupChosen = this.$refs.studentGroupTree.getCheckedNodes();
      this.dialogData.ifShow = false;
    },
    nodeClick(data, node) {
      let checkedKeys = this.$refs.studentGroupTree.getCheckedKeys(true);
      if (data.id && !checkedKeys.includes(0)) {
        // 点击的不是所有分类且没选择所有分类
        if (checkedKeys.includes(data.id)) {
          checkedKeys.splice(checkedKeys.indexOf(data.id), 1);
        } else {
          checkedKeys.push(data.id);
        }
      } else if (data.id && checkedKeys.includes(0)) {
        // 点击的不是所有分类且已选择所有分类
        checkedKeys = [data.id];
      } else {
        // 点击所有分类
        checkedKeys = [data.id];
      }
      this.$refs.studentGroupTree.setCheckedKeys(checkedKeys);
    },
    upToDatePicker(data) {
      [this.settingData.startTime, this.settingData.endTime] = data;
      console.log(
        this.settingData.startTime,
        this.settingData.endTime,
        this.settingData.upToDate
      );
    },
    navClick([firstNav, secNav]) {
      document.getElementsByClassName("contentSide")[0].scrollTop = document
        .getElementsByClassName("settingContent")
        [firstNav].getElementsByClassName("title")[secNav].offsetTop;
      console.log(
        document
          .getElementsByClassName("settingContent")
          [firstNav].getElementsByClassName("title")[secNav].offsetTop
      );
    },
    scrollInit() {
      let settingContentList = Array.from(
        document.getElementsByClassName("settingContent")
      );
      document.getElementsByClassName("contentSide")[0].onscroll = (e) => {
        let scrollTop = e.target.scrollTop;
        settingContentList.forEach((set, setIdx) => {
          if (
            set.getElementsByClassName("title")[0] &&
            set.getElementsByClassName("title")[0].offsetTop
          ) {
            this.settingActive =
              setIdx +
              "-" +
              Array.from(set.getElementsByClassName("title")).findIndex(
                (item) => {
                  return (
                    item.offsetTop && item.offsetTop - e.target.scrollTop > -70
                  );
                }
              );
          }
        });
      };
    },
    copy(data) {
      let oInput = document.createElement("input");
      oInput.value = data;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success",
      });
      oInput.remove();
    },
  },
};
const editorMenus = [
  //   "head", // 标题
  "bold", // 粗体
  "fontSize", // 字号
  "fontName", // 字体
  "italic", // 斜体
  "underline", // 下划线
  "strikeThrough", // 删除线
  "foreColor", // 文字颜色
  "backColor", // 背景颜色
  //   "link", // 插入链接
  "list", // 列表
  "justify", // 对齐方式
  "quote", // 引用
  "image", // 插入图片
  "table", // 表格
  "video", // 插入视频
  "code", // 插入代码
  "undo", // 撤销
  "redo", // 重复
];
</script>

<style scoped lang="less">
.greyFont {
  color: #ccc;
}
.redFont {
  color: #ff5e54;
}
.el-input,
.el-range-editor.el-input__inner,
.el-select {
  margin: 0 8px;
}
.wrapper {
  background: #fff;
  .stepInput {
    padding-bottom: 10px;
    text-align: left;
    .contentSide::-webkit-scrollbar {
      display: none;
    }
    .contentSide {
      overflow-y: scroll;
    }
    .contentSideCreate {
      height: calc(100vh - 240px);
    }
    .contentSideEdit {
      height: calc(100vh - 160px);
    }
    .settingContent {
      padding: 30px;
      .inputBar {
        font-size: 1.2em;
        padding: 10px 30px;
        .title {
          font-size: 1.2em;
          position: relative;
          margin: 10px 0;
        }
        .title::after {
          content: "";
          width: 4px;
          height: 100%;
          background: #36aafd;
          position: absolute;
          top: 0;
          left: -10px;
        }
        .chooseContainer {
          .showBar {
            padding: 10px;
            border: 1px solid #36aafd;
            border-radius: 5px;
            width: 80%;
            .el-button--small,
            .el-tag {
              margin-right: 10px;
            }
            min-height: 50px;
          }
        }
        .defaultDescriptBox {
          margin: 20px 0;
          width: 40%;
          min-width: 400px;
          border-radius: 4px;
          border: solid 1px #36aafd;
          padding: 15px 40px 15px 40px;
          .spaceBwteen {
            display: flex;
            justify-content: space-between;
            font-size: 1.2em;
          }
        }

        /deep/ .el-checkbox {
          // margin: 8px 30px 8px 0;
          /deep/ .el-checkbox__label {
            font-size: 1.2em;
          }
        }
        .inputSecBar {
          margin-left: 24px;
          line-height: 32px;

          .el-select {
            width: 70px;
          }
          .el-input {
            width: 60px;
          }
        }
        .imgChooseBox {
          padding: 10px 20px;
          border: 1px solid #ccc;
          color: #ccc;
          border-radius: 5px;
          text-align: center;
          display: inline-block;
          margin: 10px;
          i {
            font-size: 30px;
          }
        }
        .imgChosenBox {
          padding: 10px 20px;
          margin: 10px;
          border: 1px solid #618afd;
          color: #618afd;
          border-radius: 5px;
          text-align: center;
          display: inline-block;
          i {
            font-size: 30px;
          }
        }
        .greyTips {
          background-color: #f5f5f5;
          font-size: 14px;
          color: #666666;
          width: 82%;
          padding: 20px;
        }
      }
    }
    .paneBox {
      border: 1px solid #ccc;
      border-top: none;
      padding: 10px;
    }
    .examinationPane {
      min-height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-radio {
      margin: 10px 0;
      .el-input {
        width: 80px;
      }
    }
    /deep/ .ivu-tabs-bar {
      margin-bottom: 0;
    }
    /deep/ .el-submenu .el-menu-item {
      padding: 0 !important;
      text-align: center;
      min-width: 0;
      width: 100%;
      overflow: hidden;
    }
    /deep/ .is-opened {
      .el-submenu__title {
        background: #409eff;
        color: #fff;
      }
    }
  }
  .editorContainer {
    margin: 20px 0;
    width: 660px;
    /deep/ .w-e-toolbar {
      flex-wrap: wrap;
    }
    .keywordBar {
      .keyword {
        position: relative;
        display: inline-block;
        line-height: 24px;
        height: 24px;
        padding: 0 8px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #ccc;
        font-size: 1rem;
        margin: 15px 3px;
        .keywordHover {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
/deep/ .el-menu-item {
  text-align: left !important;
  text-indent: 30px;
}
</style>
